import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import "./a4shett.css";
import tmplLogo from "../images/tmplLogo.png";

function PaymentReference() {
  const [packages, setPackages] = useState(null);
  const [testDetails, setTestDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [data, setdata] = useState(null);
  const [invoice, setInvoice] = useState("");

  const location = useLocation();
  const appointmentData = location.state;
  const packageId = appointmentData?.packageId
  const userid = appointmentData?.userid;
  const additionalTestIds = appointmentData?.additionalTestIds || [];

  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;
  const userRole = JSON.parse(localStorage.getItem("data")).role;

  const getData = async () => {
    try {
      setLoading(true);
        if(packageId!==null){
      const response = await axios.get(`/api/package/${appointmentData?.packageId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPackages(response.data);
    }

      if (additionalTestIds && additionalTestIds.length > 0) {
        const testRequests = additionalTestIds.map((id) =>
          axios.get(`/api/labtest/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
        );

        const testResponses = await Promise.all(testRequests);
        const allTests = testResponses.map((res) => res.data);
        setTestDetails(allTests);
      } else {
        setTestDetails([]);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch package or test details");
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchEmp = async () => {
      try {
        const res = await axios.get(`/api/employeedetails/userid=${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setdata(res.data);
      } catch (error) {
        console.error("Error fetching exempted customers:", error);
      }
    };

    fetchEmp();
  }, []);

  useEffect(() => {
    const storedPaymentId = localStorage.getItem("razorpay_payment_id");
    if (storedPaymentId) {
      setInvoice(storedPaymentId);
    }
    getData();
  }, []);

  function Printbill(e) {
    window.print();
    if (appointmentData.familyid != null) {
      navigate(`/users/family-profile/${appointmentData.familyid}`);
    } else if (userRole === "ROLE_EMPLOYEE") {
      navigate(`/users/employee-appointments`);
    } else {
      navigate(`/users/employee-profile/${userid}`);
    }
  }

  const handleContinue = () => {
    if (appointmentData.familyid != null) {
      navigate(`/users/family-profile/${appointmentData.familyid}`);
    } else if (userRole === "ROLE_EMPLOYEE") {
      navigate(`/users/employee-appointments`);
    } else {
      navigate(`/users/employee-profile/${userid}`);
    }
  };

  const totalTestCost = testDetails.reduce(
    (sum, test) => sum + (test?.testCost?.cost || 0),
    0
  );

  const packagePrice = packages?.price || 0;
  const price = parseFloat(packagePrice + totalTestCost);

  // Calculate GST and platform fee
  const gstRate = 0.0;
  const platformFeeRate = 0.03;
  const platformGstRate = 0.18;

  const cgst = (price * gstRate) / 2;
  const sgst = (price * gstRate) / 2;
  const cost = price + cgst + sgst;
  const platformFee = cost * platformFeeRate;
  const platformFeeGst = platformFee * platformGstRate;
  const totalPlatformFee = platformFee + platformFeeGst;


  const totalTransactionCost = price + cgst + sgst + platformFee + platformFeeGst;

  return (
    <div>
      <style>{`
        .receipt-container {
          max-width: 900px;
          margin: 0 auto;
          padding: 40px;
        }
        
        .receipt-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 30px;
        }
        
        .company-info h6 {
          margin: 5px 0;
        }
        
        .logo-section {
          text-align: right;
        }
        
        .bill-reference-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
        }
        
        .bill-to h6 {
          margin: 5px 0;
        }
        
        .reference-number {
          text-align: right;
        }
        
        .reference-number h6 {
          margin: 5px 0;
        }
        
        .total-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 20px 0;
        }
        
        .breakdown-section {
          display: flex;
          justify-content: flex-end;
          margin: 30px 0;
        }
        
        .breakdown-details {
          text-align: right;
          min-width: 250px;
        }
        
        .breakdown-details h6 {
          margin: 8px 0;
        }
        
        .breakdown-details h2 {
          margin-top: 15px;
          padding-top: 15px;
          border-top: 2px solid #333;
        }
        
        .action-buttons {
          display: flex;
          justify-content: flex-end;
          gap: 15px;
          margin-top: 40px;
        }
        
        .divider {
          height: 2px;
          background-color: #333;
          margin: 20px 0;
        }
        
        @media print {
          .action-buttons {
            display: none;
          }
        }
      `}</style>

      <div id="layoutDrawer_content">
        <main>
          <div className="a4-sheet">
            <header className="bg-primary">
              <div className="container-xl px-5">
                <h1 className="text-white py-3 mb-0 display-6"></h1>
              </div>
            </header>

            <div className="receipt-container">
              <form>
                {/* Header Section */}
                <div className="receipt-header">
                  <div className="company-info">
                    <h5>
                      <b>RECEIPT</b>
                    </h5>
                    <br />
                    <h6>
                      <b>Timespan pvt ltd.</b>
                    </h6>
                    <h6>Bangalore, Karnataka</h6>
                    <h6>PIN</h6>
                    <h6>GSTIN- 29AAJCC7045D1ZM</h6>
                  </div>
                  <div className="logo-section">
                    <img src={tmplLogo} width="125px" alt="Company Logo" />
                  </div>
                </div>

                {/* Bill To and Reference Section */}
                <div className="bill-reference-section">
                  <div className="bill-to">
                    <h6>
                      <b>Bill To</b>
                    </h6>
                    <h6>{data?.email}</h6>
                    <h6>{data?.address}</h6>
                    <h6>PAN-{data?.pan}</h6>
                  </div>
                  <div className="reference-number">
                    <h6>
                      <b>Reference Number:</b>
                    </h6>
                    <h6>{invoice}</h6>
                  </div>
                </div>

                <div className="divider"></div>

                {/* Total Amount Header */}
                <div className="total-header">
                  <h2>Total Amount</h2>
                  <h2>{totalTransactionCost.toFixed(2)} ₹</h2>
                </div>

                <div className="divider"></div>

                {/* Breakdown Section */}
                <div className="breakdown-section">
                  <div className="breakdown-details">
                    <h6>Amount: {price.toFixed(2)}</h6>
                    <h6>CGST: {cgst.toFixed(2)}</h6>
                    <h6>SGST: {sgst.toFixed(2)}</h6>
                    <h6>Platform Fee: {totalPlatformFee.toFixed(2)}</h6>
                    <h2>Total Amount: {totalTransactionCost.toFixed(2)} ₹</h2>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                  <button
                    onClick={(e) => Printbill(e)}
                    className="btn btn-primary"
                    type="button"
                  >
                    Print
                  </button>
                  <button
                    onClick={(e) => handleContinue()}
                    className="btn btn-primary"
                    type="button"
                  >
                    Continue
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default PaymentReference;